function addGift() {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: 32371349389445,
      quantity: 1,
      properties: { '_Geschenkbox': 'Ja' }
    })
  }).then(() => {
    setTimeout(() => {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }, 1000);
  });
}

document.addEventListener('variant:add', function(e) {
  if (e.detail && e.detail.properties && e.detail.properties._Geschenkbox === 'Ja') {
    addGift();
  }
});